import { render } from "./XMLFormatter.vue?vue&type=template&id=0d1eff3a&scoped=true&ts=true"
import script from "./XMLFormatter.vue?vue&type=script&lang=ts"
export * from "./XMLFormatter.vue?vue&type=script&lang=ts"

import "./XMLFormatter.vue?vue&type=style&index=0&id=0d1eff3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d1eff3a"]])

export default __exports__